import React from 'react';
import ReactDOM from 'react-dom';

// we have to have to save hooks to the two divs in the body of public/index.html
const appRoot = document.getElementById('root');
const popupRoot = document.getElementById('popup-root');

/**
 *  Popup is a barebones, textbook implementation of
 *  a React Portal component. Taken from the
 *  React docs.
 */
export default class Popup extends React.Component {
  /** The popup will exist in this div, hooked into popupRoot */
  element = document.createElement('div');

  /**
   * Append element to popupRoot
   */
  componentDidMount() {
    popupRoot.appendChild(this.element);
  }

  /**
   * Remove element from popupRoot
   */
  componentWillUnmount() {
    popupRoot.removeChild(this.element);
  }

  /**
   *  Create a portal, render this element
   *  and its children.
   *  @return this.props.children, this.element
   */
  render() {
    return ReactDOM.createPortal(this.props.children, this.element);
  }
}



// WEBPACK FOOTER //
// ./src/Popup.js